import { render, staticRenderFns } from "./EmailRestorePasswordForm.vue?vue&type=template&id=517009cb&scoped=true&"
import script from "./EmailRestorePasswordForm.vue?vue&type=script&lang=js&"
export * from "./EmailRestorePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517009cb",
  null
  
)

export default component.exports